import React from "react";
import { CheckCircle2, Loader2, Circle } from "lucide-react";
import { useContentList, useContentObject } from "../hooks/useContentData";
import { contentFallback } from "../contentDefaults";

const Roadmap = () => {
  const { data: header } = useContentObject("home.roadmap_header", contentFallback("home.roadmap_header"));
  const { items: phases } = useContentList("home.roadmap", contentFallback("home.roadmap"));

  if (phases.length === 0) return null;

  return (
    <section className="relative py-28 bg-[#0a0a0d] overflow-hidden">
      <div className="absolute inset-0 bg-gradient-to-b from-[#111118]/40 via-transparent to-[#111118]/40" />
      <div className="relative max-w-6xl mx-auto px-6 md:px-10">
        <div className="flex flex-col items-center text-center mb-16">
          {header?.eyebrow && (
            <div className="ornament"><span>{header.eyebrow}</span></div>
          )}
          {!header?.eyebrow && <div className="ornament"><span>Camino del Héroe</span></div>}
          <h2 className="section-title mt-6">{header?.title || "Roadmap 2025 / 2026"}</h2>
          {header?.subtitle && <p className="mt-4 max-w-xl text-[#b8b3a8] text-sm">{header.subtitle}</p>}
          <div className="gold-divider w-40 mt-6" />
        </div>

        <div className="relative">
          <div className="absolute left-[15px] md:left-1/2 md:-translate-x-1/2 top-0 bottom-0 w-px bg-gradient-to-b from-transparent via-[rgba(212,168,67,0.3)] to-transparent" />
          <div className="space-y-10">
            {phases.map((p, i) => {
              const isLeft = i % 2 === 0;
              const StatusIcon = p.status === "completed" ? CheckCircle2 : p.status === "active" ? Loader2 : Circle;
              const color = p.status === "completed" ? "#10b981" : p.status === "active" ? "#d4a843" : "#6f6c66";
              const phaseItems = Array.isArray(p.items) ? p.items : [];
              return (
                <div key={i} className={`relative flex md:items-center ${isLeft ? "md:flex-row" : "md:flex-row-reverse"} gap-6`}>
                  <div className={`flex-1 pl-12 md:pl-0 ${isLeft ? "md:text-right md:pr-12" : "md:pl-12"}`}>
                    <div className="glass rounded-sm p-6 inline-block w-full md:w-auto md:max-w-md hover:translate-y-[-2px] transition-all">
                      <div className={`flex items-center gap-3 mb-3 ${isLeft ? "md:justify-end" : ""}`}>
                        <span className="font-mono text-xs text-[#d4a843] tracking-[0.2em] uppercase">{p.date}</span>
                        <span className="text-[10px] px-2 py-0.5 rounded-sm border" style={{ color, borderColor: color, backgroundColor: `${color}11` }}>
                          {p.status}
                        </span>
                      </div>
                      <h3 className="font-display font-bold text-xl text-[#f0ebe0] mb-3">{p.phase}</h3>
                      <ul className={`text-sm text-[#b8b3a8] space-y-1.5 ${isLeft ? "md:text-right" : ""}`}>
                        {phaseItems.map((it, j) => (
                          <li key={j}>· {it}</li>
                        ))}
                      </ul>
                    </div>
                  </div>
                  <div className="absolute left-0 md:left-1/2 md:-translate-x-1/2 top-2 md:top-1/2 md:-translate-y-1/2">
                    <div className="w-8 h-8 rounded-full bg-[#0a0a0d] border-2 flex items-center justify-center" style={{ borderColor: color }}>
                      <StatusIcon className={`w-4 h-4 ${p.status === "active" ? "animate-spin" : ""}`} style={{ color }} />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Roadmap;
